import type {MutableRefObject} from 'react';
import type {CabinetMesh} from 'components/customer/RoomPlanner/types';
import productEvents from 'components/customer/RoomPlanner/lib/useProductEvents';
import Camera from 'components/customer/RoomPlanner/lib/use3DRPCameraSetup';
import {store} from 'store/customer/storeSetup';

export type SyncPlaceholderEventsOptions = {
    /** Clear drag/click flags (delete or catalog click that never mouseup'd the canvas). */
    resetPointer?: boolean;
};

/**
 * Placeholder add / delete / restore / duplicate only.
 * Updates the selectable mesh list with cabinets + placeholders, and attaches
 * canvas listeners only when a placeholder-only room never went through
 * cabinet `attachEvents`. Cabinet render and room setup must keep calling
 * `productEvents.attachEvents` themselves.
 * @param {MutableRefObject<CabinetMesh[] | undefined> | undefined} cabinetGroupListRef Cabinets
 * @param {SyncPlaceholderEventsOptions=} options Pointer reset
 * @return {void}
 */
export const syncPlaceholderProductEvents = (
    cabinetGroupListRef?: MutableRefObject<CabinetMesh[] | undefined>,
    options: SyncPlaceholderEventsOptions = {}
): void => {
    productEvents.setProducts(cabinetGroupListRef?.current ?? []);

    if (options.resetPointer) {
        productEvents.resetPointerInteraction();
    }

    if (!Camera.scene || !Camera.camera || !Camera.controls) {
        return;
    }

    // Skip if cabinet/room setup already bound this canvas.
    productEvents.ensurePlaceholderCanvasEvents({
        scene: Camera.scene,
        camera: Camera.camera,
        controls: Camera.controls,
        roomType: store.getState().roomPlanner.roomType || 'RECTANGULAR',
    });
};
